// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ConfigureReminders\ConfigureRemindersViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DefaultReminders as _DefaultReminders, DefaultRemindersData as _DefaultRemindersData, DefaultRemindersOptions as _DefaultRemindersOptions } from 'data/models/ConfigureReminders';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';

// ConfigureRemindersData is the class that ConfigureReminders serializes to/from
export interface ConfigureRemindersData {
    OrganizationId : number;
	
    Organization : OrganizationData | null;
	
    DefaultReminders : _DefaultRemindersData;
}

// ConfigureRemindersOptions is the class which may be passed to the ConfigureReminders constructor to define optional initial data values
export interface ConfigureRemindersOptions {
    OrganizationId : number;
	
    Organization? : OrganizationOptions | null;
	
    DefaultReminders? : _DefaultRemindersOptions;
}

export class ConfigureReminders {
    public OrganizationId : DataSignal<number>;
	
    public Organization : DataSignal<Organization | null>;
	
    public DefaultReminders : _DefaultReminders;

    constructor();
    constructor(data : ConfigureRemindersOptions);
    constructor(data: ConfigureRemindersOptions | null = null) {
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.Organization = S.value<Organization | null>(null);
	    
        this.DefaultReminders = data && data.DefaultReminders !== undefined ? new _DefaultReminders(data.DefaultReminders) : new _DefaultReminders();
    }

    static key(obj : ConfigureReminders) {
        return obj.OrganizationId();
    }
    
    static dataKey(obj : ConfigureRemindersOptions) {
        return obj.OrganizationId;
    }

    static update(obj : ConfigureReminders, data : ConfigureRemindersOptions) {
        S.freeze(() => {
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
	        
            if (data.DefaultReminders !== undefined) _DefaultReminders.update(obj.DefaultReminders, data.DefaultReminders);
        });
    }
}

// DefaultRemindersData is the class that DefaultReminders serializes to/from
export interface DefaultRemindersData {
	
	
    DefaultFinalReminderWindow : number;
    DefaultFirstReminderWindow : number;
}

// DefaultRemindersOptions is the class which may be passed to the DefaultReminders constructor to define optional initial data values
export interface DefaultRemindersOptions {
	
	
    DefaultFinalReminderWindow? : number;
    DefaultFirstReminderWindow? : number;
}

export class DefaultReminders {
	
	
    public DefaultFinalReminderWindow : DataSignal<number>;
    public DefaultFirstReminderWindow : DataSignal<number>;

    constructor();
    constructor(data : DefaultRemindersOptions);
    constructor(data: DefaultRemindersOptions | null = null) {
	    
	    
        this.DefaultFinalReminderWindow = jsonableObservable(S.value<number>(data && data.DefaultFinalReminderWindow !== undefined ? data.DefaultFinalReminderWindow : 0));
        this.DefaultFirstReminderWindow = jsonableObservable(S.value<number>(data && data.DefaultFirstReminderWindow !== undefined ? data.DefaultFirstReminderWindow : 0));
    }

    static key(obj : DefaultReminders) {
        return ;
    }
    
    static dataKey(obj : DefaultRemindersOptions) {
        return ;
    }

    static update(obj : DefaultReminders, data : DefaultRemindersOptions) {
        S.freeze(() => {
	        
	        
            if (data.DefaultFinalReminderWindow !== undefined) obj.DefaultFinalReminderWindow(data.DefaultFinalReminderWindow);
            if (data.DefaultFirstReminderWindow !== undefined) obj.DefaultFirstReminderWindow(data.DefaultFirstReminderWindow);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ConfigureReminders.ts